<template>
  <div class="User-Dialog">
    <div class="b-sidebar-backdrop bg-dark" style="z-index:100;" v-if="Temp_Value" @click="onHidden"></div>
    <div>
      <b-sidebar id="UserSetting" right bg-variant="white" :no-close-on-backdrop="true" backdrop :no-header-close="true"
        :shadow="true" ref="UserSettingDialog" v-model="Temp_Value" header-class="UserSettingDialog-header"
        class="user-setting-sidebar">
        
        <template v-slot:header>
          <div class="UserSettingDialog-header-Div">
            <button type="button" style="border: none; background-color: transparent" @click="onHidden">
              <i class="icon-close f-14"></i>
            </button>
            <span class="UserSettingDialog-header-Title">{{ DilogTitle || $t('lbl_EMPBE_EditUser') }}</span>
          </div>
        </template>
        <PageValidate ref="UserSettingObserver">

          <template v-slot:PageBody>
            <b-overlay :show="IsDialogLoading" :rounded="'lg'" 
            :fixed="true" 
            :position="'fixed'"
            :style="IsDialogLoading ? 'min-height:400px;overflow:hidden;' : ''">

            <div class="UserSetting-Nav">
              <div v-if="IsInactiveRole" class="UserSeeting-InactiveBanner">
                <svg
                  class="UserSeeting-InactiveBanner__icon"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M8.33333 0C3.73333 0 0 3.73333 0 8.33333C0 12.9333 3.73333 16.6667 8.33333 16.6667C12.9333 16.6667 16.6667 12.9333 16.6667 8.33333C16.6667 3.73333 12.9333 0 8.33333 0ZM9.16667 12.5H7.5V10.8333H9.16667V12.5ZM9.16667 9.16667H7.5V4.16667H9.16667V9.16667Z"
                    fill="#FFD02C"
                  />
                </svg>
                <div class="UserSeeting-InactiveBanner__content">
                  <div class="UserSeeting-InactiveBanner__title">{{ $t('EMP_UserSetting_InactiveBannerTitle') }}</div>
                  <div class="UserSeeting-InactiveBanner__body">{{ $t('EMP_UserSetting_InactiveBannerBody') }}</div>
                </div>
              </div>
              <div class="UserSetting-Nav-FormBody" :class="{ 'is-readonly': IsInactiveRole }">
              <div class="UserSeeting-Nav-Role" v-if="!IsHidenRole">
                <div class="UserSeeting-Nav-Role-Header">
                  <div class="UserSeeting-Nav-Item-Title">
                    {{ $t('EMP_UserSetting_Role') }}
                  </div>
                  <div class="UserSeeting-Nav-Item-Msg">
                    {{ $t('EMP_UserSetting_RoleTip') }}
                  </div>
                </div>
                <selection ControlId="userRole" style="width: 60%;margin-bottom: 0px;"
                  :title="$t('EMP_UserSetting_AdminMember')" v-model="UserData.userRole" :options="RoleOptions"
                  :mandatory="$t('lbl_EMPBE_UserRoleRequired')"
                  :enableValidation="Temp_Value && formReadyForValidation && !IsInactiveRole">
                </selection>
              </div>
              <div class="UserSeeting-Nav-HeadLine" v-if="!IsHidenRole"></div>
              <div class="UserSeeting-Nav-HeadMsg">
                <div class="UserSeeting-Nav-Msg">
                  <div class="UserSeeting-Nav-Img">
                    <mediaUploader
                      :key="AccountUserId"
                      ref="userLogo"
                      :isAvatar="true"
                      :isShowEditPen="true"
                      :IsRequired="false"
                      :MediaArray="logoUploadedFiles"
                      aspectRatioStr="1:1"
                      :limit="1"
                      :maxSize="5"
                      galleryItemStyle="height: 78px; width: 78px; border-radius: 999px;"
                      mediaType="image"
                      :fileUsageType="fileUsageType"
                      filePathEndpoint="Image"
                      @update="handleUserIconUpdate"
                    />
                  </div>
                  <div class="UserSeeting-Nav-Info">
                    <div class="UserSeeting-Nav-Name">
                      <div class="UserSeeting-Nav-Item-Title">{{ $t('EMP_UserSetting_ProfilePicture') }}</div>
                      <div class="UserSeeting-Nav-Recommend">
                        <div class="UserSeeting-Nav-Recommend-Text">{{ $t('EMP_UserSetting_Recommended') }}</div>
                      </div>
                    </div>
                    <div class="UserSeeting-Nav-size ">{{ $t('EMP_UserSetting_ProfilePictureSize') }}
                    </div>
                    <div class="UserSeeting-Nav-Tips ">
                      <div>
                        <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/light_bulb.svg" class="UserSetting_Night_Icon" alt="" />
                        <span>{{ $t('EMP_UserSetting_ProfilePictureTip') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="UserSeeting-Nav-ProfileDetails">
                  <div class="UserSeeting-Nav-Item-Title">
                    {{ $t('EMP_UserSetting_ProfileDetails') }}
                  </div>
                  <div class="UserSeeting-Nav-ProfileDetails-Content">
                    <textbox :title="$t('EMP_UserSetting_FullNameEnglish')" type="text" v-model="UserData.personNameEn"
                      ControlId="personNameEn" :mandatory="$t('EMP_UserSetting_FullNameEnglish') + $t('lbl_IsRequire')">
                    </textbox>
                    <textbox :title="$t('EMP_UserSetting_FullNameChinese')" type="text" v-model="UserData.personNameSc"
                      ControlId="personNameSc" :mandatory="$t('EMP_UserSetting_FullNameChinese') + $t('lbl_IsRequire')">
                    </textbox>
                    <textbox :title="$t('EMP_UserSetting_JobTitleEnglish')" type="text" v-model="UserData.jobTitleEn"
                      ControlId="jobTitleEn" :mandatory="$t('EMP_UserSetting_JobTitleEnglish') + $t('lbl_IsRequire')">
                    </textbox>
                    <textbox :title="$t('EMP_UserSetting_JobTitleChinese')" type="text" v-model="UserData.jobTitleSc"
                      ControlId="jobTitleSc" :mandatory="$t('EMP_UserSetting_JobTitleChinese') + $t('lbl_IsRequire')">
                    </textbox>
                  </div>
                  <div class="OnlydisplayContactCard" v-if="!IsHidenRole">
                    <div class="displayContactCard">
                      <switchIput size="medium" style="margin-bottom:0px" ControlId="displayContactCard" :IsHidenText="true"
                        v-model="UserData.displayContactCard">
                      </switchIput>
                      <div class="displayContactCard-Div">
                        <div class="displayContactCard-Div-Header">
                          <div class="displayContactCard-Div-Title">
                            {{ $t('EMP_UserSetting_SetAsEBoothRepresentative', { currentQuota: (UserData.otherAccountUserId || 0) > 0 ? 1 : 0 }) }}
                          </div>
                        </div>
                        <div class="displayContactCard-Div-Text" v-html="$t('EMP_UserSetting_eBoothRepresentativeTipUpdated')">
                        </div>
                        <div class="OnlydisplayContactCard-Name" v-if="UserData.otherAccountUserId">
                          {{ $t('EMP_UserSetting_CurrentRepresentative', { currentUserSet: (langid == '1252' || langid == 1252) ? (UserData.displayContactCardPersonNameEn || AccountUserData?.displayContactCardPersonNameEn) : (UserData.displayContactCardPersonNameSc || AccountUserData?.displayContactCardPersonNameSc) }) }}
                        </div>
                      </div>
                    </div>

                    <!-- 是否互换名片：第二行，整体向右缩进，与标题文字对齐 -->
                    <div
                      class="displayContactCard-AutoRow"
                      v-if="UserData.displayContactCard"
                      style="margin: 0px 0px 0px 68px; display: flex; gap: 12px; align-items: center;"
                    >
                      <switchIput
                        size="medium"
                        style="margin-bottom:0px"
                        ControlId="isExchangeNameCard"
                        :IsHidenText="true"
                        v-model="UserData.isExchangeNameCard">
                      </switchIput>
                      <div class="displayContactCard-AutoRow-Content">
                        <div class="displayContactCard-Div-Title">
                          {{ $t('EMP_UserSetting_AutoExchangeNameCard') }}
                        </div>
                        <div class="displayContactCard-Div-Text">
                          {{ $t('EMP_UserSetting_AutoExchangeNameCardTip') }}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="UserSeeting-Nav-MobileMail">
                <div class="UserSeeting-Nav-MobileMail-Header">
                  <div class="UserSeeting-Nav-Item-Title">
                    {{ $t('EMP_UserSetting_MobileEmail') }}
                  </div>
                  <div class="UserSeeting-Nav-Item-Msg">
                    {{ $t('EMP_UserSetting_MobileEmailTip') }}
                  </div>
                </div>
                <div class="UserSeeting-Nav-MobileMail-Content">
                  <div class="UserSeeting-Nav-Item">
                    <div class="UserSeeting-Nav-Item-Left">
                      <i class="UserSetting_phone_Icon"></i>
                      <div class="UserSeeting-Nav-Item-Left-Content">
                      <div class="UserSeeting-Nav-Item-Left-MsgVerify">
                        <span :class="{ 'not-setup-text': !UserData.phoneValue }">{{ GetPhoneDetail }}</span>
                        <i v-if="UserData.phoneValue"
                          :class="`${UserData.phoneIsVerify ? 'UserSetting_IsVersion_Icon' : 'UserSetting_IsVersion_Icon_None'}`"></i>
                        <img v-if="phoneDuplicateError" src="https://cdn.adsalecdn.com/EMP/Backend/svg/PublicTabs/warn.svg" 
                          alt="warning" style="width: 16px; height: 16px; margin-left: 4px;" />
                      </div>
                      <div v-if="UserData.lastLoginPhone" class="UserSeeting-Nav-Item-Right-Timer">{{ $t('lbl_EMPBE_UserSetting_Timer', { timer: UserData.lastLoginPhone }) }}</div>
                      <div v-if="phoneDuplicateError" class="UserSeeting-Nav-Item-Error">
                        {{ $t('EMP_UserSetting_MobileUsedInlineError') }}
                        </div>
                      </div>
                    </div>
                    <div class="UserSeeting-Nav-Item-Right">
                      <b-button variant="outline-primary" v-bind:t_label="UserData.phoneValue ? 'EMP_UserSetting_Edit' : 'EMP_UserSetting_SetUp'"
                        @click="EditDialog('Mobile')">
                        {{ UserData.phoneValue ? $t('EMP_UserSetting_Edit') : $t('EMP_UserSetting_SetUp') }}
                      </b-button>
                    </div>
                  </div>
                  <div class="UserSeeting-Nav-Item">
                    <div class="UserSeeting-Nav-Item-Left">
                      <i class="UserSetting_Email_Icon"></i>
                      <div class="UserSeeting-Nav-Item-Left-Content">
                      <div class="UserSeeting-Nav-Item-Left-MsgVerify">
                        <span v-if="UserData.emailValue">{{ UserData.emailValue }}</span>
                        <span v-else class="not-setup-text">{{ $t('EMP_UserSetting_EmailNotSetUp') }}</span>
                        <i v-if="UserData.emailValue"
                          :class="`${UserData.emailIsVerify ? 'UserSetting_IsVersion_Icon' : 'UserSetting_IsVersion_Icon_None'}`"></i>
                        <img v-if="emailDuplicateError" src="https://cdn.adsalecdn.com/EMP/Backend/svg/PublicTabs/warn.svg" 
                          alt="warning" style="width: 16px; height: 16px; margin-left: 4px;" />
                      </div>
                      <div v-if="UserData.lastLoginEmail" class="UserSeeting-Nav-Item-Right-Timer">{{ $t('lbl_EMPBE_UserSetting_Timer', { timer: UserData.lastLoginEmail }) }}</div>
                      <div v-if="emailDuplicateError" class="UserSeeting-Nav-Item-Error">
                        {{ $t('EMP_UserSetting_EmailUsedInlineError') }}
                        </div>
                      </div>
                    </div>
                    <div class="UserSeeting-Nav-Item-Right">
                      <b-button variant="outline-primary" v-bind:t_label="UserData.emailValue ? 'EMP_UserSetting_Edit' : 'EMP_UserSetting_SetUp'"
                        @click="EditDialog('Email')">
                        {{ UserData.emailValue ? $t('EMP_UserSetting_Edit') : $t('EMP_UserSetting_SetUp') }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="UserSeeting-Nav-Tips-Center">
                <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/light_bulb.svg" class="UserSetting_Night_Icon" alt="" />
                <div class="UserSeeting-Nav-Tips-Center-Nav">
                  <div class="UserSeeting-Nav-Tips-Center-Title">{{ $t('EMP_UserSetting_Suggestion') }}</div>
                  <div class="UserSeeting-Nav-Tips-Center-Content">{{ $t('EMP_UserSetting_SuggestionTip') }}</div>
                </div>
              </div>
              <div class="UserSeeting-Nav-LoginType">
                <div class="UserSeeting-Nav-LoginType-Header">
                  <div class="UserSeeting-Nav-Item-Title">
                    {{ $t('EMP_UserSetting_Login') }}
                  </div>
                  <div class="UserSeeting-Nav-Item-Msg">
                    {{ $t('EMP_UserSetting_PasswordTip') }}
                  </div>
                </div>

                <div class="UserSeeting-Nav-Item">
                  <div class="UserSeeting-Nav-Item-Left">
                    <i class="UserSetting_Password_Icon"></i>
                    <div class="UserSeeting-Nav-Item-Left-Content">
                      <div v-if="IsShowPassword" class="UserSeeting-Nav-Item-Left-PasswordLabel">{{ $t('EMP_UserSetting_PasswordMasked') }}</div>
                      <div class="UserSeeting-Nav-Item-Left-MsgVerify">
                        <span v-if="IsShowPassword">*********</span>
                        <span v-else class="not-setup-text">{{ $t('EMP_UserSetting_PasswordNotSetUp') }}</span>
                      </div>
                      <div v-if="UserData.lastLoginPassword" class="UserSeeting-Nav-Item-Right-Timer">{{ $t('lbl_EMPBE_UserSetting_Timer', { timer: UserData.lastLoginPassword }) }}</div>
                    </div>
                  </div>
                  <div class="UserSeeting-Nav-Item-Right">
                    <b-button variant="outline-primary" v-bind:t_label="IsShowPassword ? 'EMP_UserSetting_Edit' : 'EMP_UserSetting_SetUp'"
                      @click="ChangePassword">
                      {{ IsShowPassword ? $t('EMP_UserSetting_Edit') : $t('EMP_UserSetting_SetUp') }}
                    </b-button>
                  </div>
                </div>
                <div class="UserSeeting-Nav-Item-Msg" v-if="false">
                  {{ $t('EMP_UserSetting_SocialLoginTip') }}
                </div>
                <div class="UserSeeting-Nav-OtherType" v-if="false">
                  <div class="UserSeeting-Nav-Item">
                    <div class="UserSeeting-Nav-Item-Left">
                      <img src="https://cdn.adsalecdn.com/EMP/Backend/svg/UserSetting/Wechat.svg" />

                      <div class="UserSeeting-Nav-Item-Left-OtherTypeMsg">
                        <div class="UserSeeting-Nav-Item-Left-OtherTypeMsg-Tilte">{{ $t('EMP_UserSetting_WeChat') }}</div>
                        <div class="UserSeeting-Nav-Item-Left-OtherTypeMsg-Msg">ID: {{ UserData.wechatValue }}</div>
                        <div v-if="UserData.lastLoginWechat" class="UserSeeting-Nav-Item-Right-Timer">{{ $t('lbl_EMPBE_UserSetting_Timer', { timer: UserData.lastLoginWechat }) }}</div>
                      </div>
                    </div>
                    <div class="UserSeeting-Nav-Item-Right">
                      <b-button variant="outline-primary" v-bind:t_label="'EMP_UserSetting_Disconnect'">
                        {{ $t('EMP_UserSetting_Disconnect') }}
                      </b-button>
                    </div>
                  </div>
                  <div class="UserSeeting-Nav-Item">
                    <div class="UserSeeting-Nav-Item-Left">

                      <img src="https://cdn.adsalecdn.com/EMP/Backend/svg/UserSetting/Google.svg" />
                      <div class="UserSeeting-Nav-Item-Left-OtherTypeMsg">
                        <div class="UserSeeting-Nav-Item-Left-OtherTypeMsg-Tilte">{{ $t('EMP_UserSetting_Google') }}</div>
                        <div class="UserSeeting-Nav-Item-Left-OtherTypeMsg-Msg">{{ $t('EMP_UserSetting_ConnectedAs', { socialMediaUserName: 'John Doe' }) }}</div>
                        <div v-if="UserData.lastLoginGoogle" class="UserSeeting-Nav-Item-Right-Timer">{{ $t('lbl_EMPBE_UserSetting_Timer', { timer: UserData.lastLoginGoogle }) }}</div>
                      </div>
                    </div>
                    <div class="UserSeeting-Nav-Item-Right">
                      <b-button variant="outline-primary" v-bind:t_label="'EMP_UserSetting_Disconnect'">
                        {{ $t('EMP_UserSetting_Disconnect') }}
                      </b-button>
                    </div>
                  </div>
                  <div class="UserSeeting-Nav-Item">
                    <div class="UserSeeting-Nav-Item-Left">

                      <img src="https://cdn.adsalecdn.com/EMP/Backend/svg/UserSetting/LinkedIn.svg" />
                      <div class="UserSeeting-Nav-Item-Left-OtherTypeMsg">
                        <div class="UserSeeting-Nav-Item-Left-OtherTypeMsg-Tilte">{{ $t('EMP_UserSetting_LinkedIn') }}</div>
                        <div class="UserSeeting-Nav-Item-Left-OtherTypeMsg-Msg">{{ $t('EMP_UserSetting_ConnectedAs', { socialMediaUserName: 'John Doe' }) }}</div>
                        <div v-if="UserData.lastLoginLinkedIn" class="UserSeeting-Nav-Item-Right-Timer">{{ $t('lbl_EMPBE_UserSetting_Timer', { timer: UserData.lastLoginLinkedIn }) }}</div>
                      </div>
                    </div>
                    <div class="UserSeeting-Nav-Item-Right">
                      <b-button variant="outline-primary" v-bind:t_label="'EMP_UserSetting_Disconnect'">
                        {{ $t('EMP_UserSetting_Disconnect') }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="UserSeeting-Nav-Notifications">
                <div class="UserSeeting-Nav-Notifications-Header">
                  <div class="UserSeeting-Nav-Item-Title">
                    {{ $t('EMP_UserSetting_Notifications') }}
                  </div>
                </div>
                <div class="UserSeeting-Nav-Notifications-Content">
                  <Expansionboard :expanded="true">
                    <template v-slot:headerLeft>
                      <switchIput class="mt-2" style="margin-bottom: 0px;" size="medium" ControlId="SetasContactPerson" :IsHidenText="true"
                        v-model="SetasContactPerson">
                      </switchIput>
                    </template>
                    <template v-slot:headerRight>
                      <div class="Expansionboard-Nav-Header-tips">
                        <div class="Expansionboard-Nav-TextBold">{{ $t('EMP_UserSetting_SetAsContactPerson') }}</div>
                        <div class="Expansionboard-Nav-Text" v-html="$t('EMP_UserSetting_SetAsContactPersonTip')"></div>
                      </div>
                    </template>
                    <template v-slot:content1>
                      <div class="Expansionboard-Nav">
                        <switchIput size="small" class="mt-2" ControlId="notifyEnquiry" :IsHidenText="true"
                          v-model="UserData.notifyEnquiry">
                        </switchIput>
                        <div class="Expansionboard-Nav-Text" v-html="$t('EMP_UserSetting_ReceiveEnquiries')"></div>
                      </div>
                    </template>
                    <template v-slot:content2>
                      <div class="Expansionboard-Nav">
                        <switchIput size="small" class="mt-2" ControlId="notifyNameCard" :IsHidenText="true"
                          v-model="UserData.notifyNameCard">
                        </switchIput>
                        <div class="Expansionboard-Nav-Text" v-html="$t('EMP_UserSetting_ReceiveNameCard')"></div>
                      </div>
                    </template>
                    <template v-slot:content3>
                      <div class="Expansionboard-Nav">
                        <switchIput size="small" class="mt-2" ControlId="notifyBookmark" :IsHidenText="true"
                          v-model="UserData.notifyBookmark">
                        </switchIput>
                        <div class="Expansionboard-Nav-Text" v-html="$t('EMP_UserSetting_ReceiveLikes')"></div>
                      </div>
                    </template>
                    <template v-slot:content4>
                      <div class="Expansionboard-Nav">
                        <switchIput size="small" class="mt-2" ControlId="notifySourcing" :IsHidenText="true"
                          v-model="UserData.notifySourcing">
                        </switchIput>
                        <div class="Expansionboard-Nav-Text" v-html="$t('EMP_UserSetting_ReceiveBusinessMatching')">
                        </div>
                      </div>
                    </template>
                    <template v-slot:content5>
                      <div class="Expansionboard-Nav">
                        <switchIput size="small" class="mt-2" ControlId="notifySystem" :IsHidenText="true"
                          v-model="UserData.notifySystem">
                        </switchIput>
                        <div class="Expansionboard-Nav-Text" v-html="$t('EMP_UserSetting_ReceiveSystemNotifications')"></div>
                      </div>
                    </template>
                    <template v-slot:content6>
                      <div class="Expansionboard-Nav">
                        <switchIput size="small" class="mt-2" ControlId="notifyAds" :IsHidenText="true" v-model="UserData.notifyAds">
                        </switchIput>
                        <div class="Expansionboard-Nav-Text" v-html="$t('EMP_UserSetting_ReceiveAdvertisementNotifications')">
                        </div>
                      </div>
                    </template>
                  </Expansionboard>
                </div>
                <div class="UserSeeting-Nav-Notifications-Footer">
                  <div class="UserSeeting-Nav-Notifications-Footer-Left">
                    <div class="Expansionboard-Nav-TextBold">
                      {{ $t('EMP_UserSetting_PreferredLanguage') }}
                    </div>
                    <div class="UserSeeting-Nav-Item-Msg">
                      {{ $t('EMP_UserSetting_PreferredLanguageTip') }}
                    </div>
                  </div>
                  <div class="UserSeeting-Nav-Notifications-Footer-Right">
                    <selection ControlId="mainLangId" autocomplete="off" class="w-100" :title="$t('lbl_EMPBE_PleaseSelect')"
                      style="margin-bottom: 0px;" v-model="UserData.mainLangId" :options="LangOptions"
                      :mandatory="$t('EMP_UserSetting_PreferredLanguageTip') + $t('lbl_IsRequire')" :allowInput="false">
                    </selection>
                  </div>
                </div>
              </div>
              </div><!-- /.UserSetting-Nav-FormBody -->

              <div
                v-if="ShouldShowAccountActions"
                class="UserSeeting-Nav-AccountActions"
              >
                <div class="UserSeeting-Nav-HeadLine"></div>
                <div class="UserSeeting-Nav-Item-Title">
                  {{ $t('EMP_UserSetting_AccountsDeactivationTitle') }}
                </div>
                <div class="UserSeeting-Nav-AccountActions-Card">
                  <div class="UserSeeting-Nav-AccountActions-Row" v-if="CanDisableUser">
                    <div class="UserSeeting-Nav-AccountActions-Copy">
                      <div class="UserSeeting-Nav-AccountActions-Label">
                        {{ $t('EMP_UserSetting_DeactivateAccount') }}
                      </div>
                      <div class="UserSeeting-Nav-AccountActions-Tip">
                        {{ $t('EMP_UserSetting_DeactivateAccountTip') }}
                      </div>
                    </div>
                    <button
                      type="button"
                      class="UserSeeting-Nav-AccountActions-Btn UserSeeting-Nav-AccountActions-Btn--primary"
                      :disabled="IsDialogLoading"
                      @click="DisableUser"
                    >
                      {{ $t('EMP_UserSetting_DisableUser') }}
                    </button>
                  </div>
                  <div class="UserSeeting-Nav-AccountActions-Row" v-if="CanEnableUser">
                    <div class="UserSeeting-Nav-AccountActions-Copy">
                      <div class="UserSeeting-Nav-AccountActions-Label">
                        {{ $t('EMP_UserSetting_ActivateAccount') }}
                      </div>
                      <div class="UserSeeting-Nav-AccountActions-Tip">
                        {{ $t('EMP_UserSetting_ActivateAccountTip') }}
                      </div>
                    </div>
                    <button
                      type="button"
                      class="UserSeeting-Nav-AccountActions-Btn UserSeeting-Nav-AccountActions-Btn--success"
                      :disabled="IsDialogLoading"
                      t_label="EMP_UserSetting_EnableUser"
                      @click="EnableUser"
                    >
                      {{ $t('EMP_UserSetting_EnableUser') }}
                    </button>
                  </div>
                  <div
                    v-if="(CanDisableUser || CanEnableUser) && ShouldShowDeleteButton"
                    class="UserSeeting-Nav-AccountActions-Divider"
                  ></div>
                  <div class="UserSeeting-Nav-AccountActions-Row" v-if="ShouldShowDeleteButton">
                    <div class="UserSeeting-Nav-AccountActions-Copy">
                      <div class="UserSeeting-Nav-AccountActions-Label">
                        {{ $t('EMP_UserSetting_DeleteAccount') }}
                      </div>
                      <div class="UserSeeting-Nav-AccountActions-Tip">
                        {{ $t('EMP_UserSetting_DeleteAccountTip') }}
                      </div>
                    </div>
                    <button
                      type="button"
                      class="UserSeeting-Nav-AccountActions-Btn UserSeeting-Nav-AccountActions-Btn--danger"
                      :disabled="IsDialogLoading"
                      @click="Delete"
                    >
                      {{ $t('EMP_UserSetting_DeleteUser') }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="Button-Group single-button" v-if="!IsInactiveRole">
                <b-button variant="primary" v-bind:t_label="'EMP_UserSetting_Save'" @click="Save(false)">
                  {{ $t('EMP_UserSetting_Save') }}
                </b-button>
              </div>
            </div>
            </b-overlay>
          </template>
        </PageValidate>
      </b-sidebar>
    </div>
    <UserSettingTips :type="ModalType" v-model="ShowModal" :emailMobileData="emailMobileData"
      :isEBoothRep="UserData.displayContactCard" :isContactPerson="SetasContactPerson"
      :hasPhone="!!UserData.phoneValue" :hasEmail="!!UserData.emailValue"
      @SaveEmailMobile="SaveEmailMobileFunc" @SavePassword="SavePasswordFunc" @DelEmailMobile="DelEmailMobileFunc">
    </UserSettingTips>
  </div>
</template>

<script>
import { userService, CompanyInfoService, LogService } from "@/_services";
import Expansionboard from '@/components/Expansionboard/Expansionboard.vue';
import UserSettingTips from './UserSettingTips.vue';
import { AlertDialog } from "../../_helpers/AlertDialog";
import mediaUploader from "../../components/form/upload/imgUploader/mediaUploader.vue";
import { mapState } from 'vuex';
import { getInitImageDataObj } from '@/_helpers/media-uploader-utils.js';

const defaultUploadResult = {
  isSuccessful: true,
  message: "",
  failedItems: [],
};

export default {
  components: {
      Expansionboard,
      UserSettingTips,
  },
  mixins: [AlertDialog],
  props: {
    AccountUserId:
    {
      type: Number,
      default: 0
    },
    companyId: {
      type: [String, Number],
      default: null
    },
    DilogTitle: {
      type: String,
      default: 'Edit User'
    },
    value: {
      type: Boolean,
      default: false
    },
    IsHidenRole:{
      type: Boolean,
      default: false
    }
  },
  components: {
    Expansionboard,
    UserSettingTips,
    mediaUploader
  },
  data() {
    return {
      IsDialogLoading: false,
      IsCreated: false,
      emailMobileData: {
        emailInput: '',
        mobileInput: '',
        contactPhoneCountryCode: '',
        contactPhoneCountry: '',
      },
      cellCountryOptions: [],
      RoleOptions: [],
      AllRoleOptions: [],
      ShowModal: false,
      ModalType: 0,
      Temp_Value: false,
      // 打开抽屉并完成数据重置前先关掉角色必填，避免上次保存校验残留导致红字闪一下
      formReadyForValidation: false,
      SetasContactPerson: false,
      isCanDelete: false,
      isCheckingDeletePermission: false,
      Init_UserData: {},
      phoneDuplicateError: false,
      emailDuplicateError: false,
      isAutoUpdatingContactPerson: false, // 标记是否是自动更新顶部开关（由底部选项改变触发）
      AccountUserData: {
        otherAccountUserId: 0,
        displayContactCardVal: false,
        displayContactCardPersonNameSc: '',
        displayContactCardPersonNameEn: ''
      },
      UserData: {
        accountUserId: this.AccountUserId,
        userRole: '',
        isDisable: false,
        personNameSc: '',
        personNameEn: '',
        jobTitleSc: '',
        jobTitleEn: '',
        mainLangId: 1252,
        notifyAds: false,
        notifyEnquiry: false,
        notifySourcing: false,
        notifySystem: false,
        notifyNameCard: false,
        notifyBookmark: false,
        // 是否互换名片（仅当设置为展台代表时才允许勾选）
        isExchangeNameCard: false,
        displayContactCard: false,
        phoneValue: '',
        phoneCountry: '',
        phoneIsVerify: false,
        googleValue: '',
        googleIsVerify: false,
        linkedInValue: '',
        linkedInIsVerify: false,
        passwordValue: '',
        passwordValueText: '',
        passwordValueVector: '',
        passwordIsVerify: false,
        emailValue: '',
        emailIsVerify: false,
        wechatValue: '',
        wechatIsVerify: false,
        lastLoginPhone: '',
        lastLoginEmail: '',
        lastLoginPassword: '',
        lastLoginWechat: '',
        lastLoginLinkedIn: '',
        lastLoginGoogle: '',
        userLogo: '',
      },

      logoUploadedFiles: [],
      dbUpdateCommands: [],
      pendingUploadFiles: [],
      uploadResult: { ...defaultUploadResult },
    }
  },
  computed: {
    ...mapState("submitFormMessage", { isShowSubmitAlertMessage : "isShowModal" }),

    fileUsageType() {
      return "AccountUserIcon";
    },
    IsShowPassword() {
      return this.UserData.passwordValueText || this.UserData.passwordValue;
    },
    IsAdd() {
      return this.AccountUserId == 0;
    },
    ShouldShowDeleteButton() {
      return !this.IsAdd && this.isCanDelete && !this.isCheckingDeletePermission;
    },
    IsInactiveRole() {
      const v = this.UserData?.isDisable;
      return v === true || v === 1 || v === '1';
    },
    CanDisableUser() {
      return this.ShouldShowDeleteButton && !this.IsInactiveRole;
    },
    CanEnableUser() {
      return this.ShouldShowDeleteButton && this.IsInactiveRole;
    },
    ShouldShowAccountActions() {
      return !this.IsAdd && !this.IsHidenRole
        && (this.CanDisableUser || this.CanEnableUser || this.ShouldShowDeleteButton);
    },
    GetPhoneDetailPrefix() {
      return this.cellCountryOptions.find(item => item.id == this.UserData.phoneCountry + '')?.label;
    },
    GetPhoneDetail() {
      if (!this.UserData.phoneValue) return this.$t('EMP_UserSetting_MobileNotSetUp')
      const sanitizedPhone = String(this.UserData.phoneValue || '').replace(/^\+/, '');
      return this.GetPhoneDetailPrefix ? `${this.GetPhoneDetailPrefix} ${sanitizedPhone}` : sanitizedPhone;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    LangOptions() {
      // 语言选项固定显示：简体中文、繁體中文、English
      // 保存的值使用 langid（保持不变）
      return [
        { id: '936', label: '简体中文' },   // 简体中文
        { id: '950', label: '繁體中文' },   // 繁体中文
        { id: '1252', label: 'English' }     // 英文
      ];
    },
  },
  watch: {
    isShowSubmitAlertMessage: {
      handler(newValue, oldValue) {
        if (newValue === false && oldValue === true) {
          this.AfterHideMessageModal();
        }
      }
    },

    SetasContactPerson(newVal, oldVal) {
      // 如果尝试开启联系人，检查是否有手机号或邮箱
      if (newVal && !oldVal) {
        if (!this.UserData.phoneValue && !this.UserData.emailValue) {
          // 阻止开启，恢复原值
          this.$nextTick(() => {
            this.SetasContactPerson = false;
          });
          // 显示提示弹窗
          this.showOnlyOkShow(
            this.$t('EMP_UserSetting_PleaseSetUpMobileOrEmail'),
            this.$t('EMP_UserSetting_MustSetMobileOrEmailBeforeContactPerson'),
            this.$t('lbl_EMPBE_Confirm')
          );
          return;
        }
      }
      
      // 如果尝试关闭联系人，但用户是展台代表，则不允许关闭
      if (!newVal && oldVal && this.UserData.displayContactCard) {
        // 阻止关闭，恢复原值
        this.$nextTick(() => {
          this.SetasContactPerson = true;
        });
        // 显示提示弹窗
        this.showOnlyOkShow(
          this.$t('EMP_UserSetting_ContactPersonCannotBeDisabled'),
          this.$t('EMP_UserSetting_ContactPersonCannotBeDisabledMsg'),
          this.$t('lbl_EMPBE_Confirm')
        );
        return;
      }
      
      // 自动回填 / 抽屉未打开：不执行全选，避免误标 dirty
      if (this.isAutoUpdatingContactPerson || this.IsCreated || !this.Temp_Value) {
        return;
      }
      
      // 这是用户手动触发顶部开关，执行全选/全不选操作
      this.UserData.notifyAds = this.SetasContactPerson;
      this.UserData.notifyEnquiry = this.SetasContactPerson;
      this.UserData.notifySourcing = this.SetasContactPerson;
      this.UserData.notifySystem = this.SetasContactPerson;
      this.UserData.notifyNameCard = this.SetasContactPerson;
      this.UserData.notifyBookmark = this.SetasContactPerson;
    },
    'UserData.displayContactCard'(newVal, oldVal) {
      // 如果尝试开启展台代表，检查是否有手机号或邮箱
      if (newVal && !oldVal) {
        // 联动需求：开启“网上展台代表”时，同步开启“自动互换名片”
        if(!this.IsCreated) this.UserData.isExchangeNameCard = true;
        if (!this.UserData.phoneValue && !this.UserData.emailValue) {
          // 阻止开启，恢复原值
          this.$nextTick(() => {
            this.UserData.displayContactCard = false;
          });
          // 显示提示弹窗
          this.showOnlyOkShow(
            this.$t('EMP_UserSetting_PleaseSetUpMobileOrEmail'),
            this.$t('EMP_UserSetting_MustSetMobileOrEmailBeforeEBoothRep'),
            this.$t('lbl_EMPBE_Confirm')
          );
          return;
        }
        
        // 如果开启展台代表，自动开启联系人
        if (!this.SetasContactPerson && !this.IsCreated) {
          this.SetasContactPerson = true;
        }
      }
      // 联动需求：关闭“网上展台代表”时，同步关闭“自动互换名片”
      if (!newVal && oldVal && !this.IsCreated) {
        this.UserData.isExchangeNameCard = false;
      }
    },
    UserData: {
      handler() {
        // 仅抽屉打开且非初始化/加载中时，才视为用户改动
        if (this.Temp_Value && !this.IsCreated && !this.IsDialogLoading) {
          this.$store.state.dirty = true;
        }
        this.ChangeIsAContactPerson();
      }, deep: true

    },
    'UserData.userRole'() {
      this.applyRoleOptionsFilter();
    },
    'UserData.isDisable'(newVal) {
      this.applyRoleOptionsFilter();
      if (newVal === true || newVal === 1 || newVal === '1') {
        this.UserData.displayContactCard = false;
        this.UserData.isExchangeNameCard = false;
        this.SetasContactPerson = false;
        this.UserData.notifyAds = false;
        this.UserData.notifyEnquiry = false;
        this.UserData.notifySourcing = false;
        this.UserData.notifySystem = false;
        this.UserData.notifyNameCard = false;
        this.UserData.notifyBookmark = false;
      }
    },
    AccountUserId() {
      this.applyRoleOptionsFilter();
    },
    value() {
      this.Temp_Value = this.value;
    },
    Temp_Value() {
      if (this.Temp_Value) {
        // 先关掉必填，避免打开瞬间用空角色顶着上次校验状态报红
        this.formReadyForValidation = false;
        // 先挡住 dirty，避免重置/回填 UserData 被当成未保存改动
        this.IsCreated = true;
        this.$store.state.dirty = false;
        this.applyRoleOptionsFilter();
        this.UserData = {
          ...JSON.parse(JSON.stringify(this.Init_UserData)),
          accountUserId: 0,
          displayContactCard: false,
          otherAccountUserId: 0,
        };
        // 清空 AccountUserData 的旧值
        if (this.AccountUserData) {
          this.AccountUserData.otherAccountUserId = 0;
          this.AccountUserData.displayContactCardPersonNameSc = null;
          this.AccountUserData.displayContactCardPersonNameEn = null;
        }
        
        this.isCanDelete = false;
        this.isCheckingDeletePermission = true;
        this.GetUserDetailFunc();
        this.GetCurrentDisplayContactCardFunc();
        this.phoneDuplicateError = false;
        this.emailDuplicateError = false;
        this.$nextTick(() => {
          this.resetFormVerify();
          this.formReadyForValidation = true;
          this.$nextTick(() => {
            this.resetFormVerify();
          });
        });
      }
      else {
        this.formReadyForValidation = false;
        this.IsCreated = true;
        this.UserData = JSON.parse(JSON.stringify(this.Init_UserData));
        this.isCanDelete = false;
        this.isCheckingDeletePermission = false;
        this.$store.state.dirty = false;
        this.IsCreated = false;
        this.$nextTick(() => {
          this.resetFormVerify();
        });
      }
      this.$emit('input', this.Temp_Value);
    }
  },
  mounted() {
    this.Init_UserData = JSON.parse(JSON.stringify(this.UserData));
    this.GetRoleOptionsFunc();
    this.getCellCountryOptions();
    this.GetUserDetailFunc();
    this.GetCurrentDisplayContactCardFunc();
  },
  methods: {
    AfterHideMessageModal() {
      this.uploadResult = { ...defaultUploadResult };
    },

    LogPageFormError(dataObj, action) {
      LogService.LogFormErrorWithObj(
        {
          EmpCompanyId: this.companyId,
          EmpProductId: 0,
          PageName: this.$route.path.split("/")[1],
          Action: action,
        },
        {
          ...dataObj,
          accUserId: this.AccountUserId,
        }
      );
    },

    uploadFinish(failedFilesFields) {
      const isSuccess = failedFilesFields.length === 0;

      this.uploadResult.isSuccessful = isSuccess;
      this.uploadResult.failedItems = [...this.uploadResult.failedItems, ...failedFilesFields];

      this.$submitFormMessage.FinishUploadPopup({ isSuccess });
    },

    showResultMessagePopup(isSuccess, message, isSubmit) {
      const isSuccessful = isSuccess && this.uploadResult.isSuccessful;
      const uploadFailedItems = this.uploadResult.failedItems;

      this.$submitFormMessage.ShowResultPopup({ isSuccess: isSuccessful, message, isSubmit, uploadFailedItems });
    },

    // [BLK] Only update the stored data arrays for later manipulation
    handleUserIconUpdate(commands, pendingFiles) {
      this.dbUpdateCommands = [...commands];
      this.pendingUploadFiles = [...pendingFiles];
    },

    resetFilePendingUpdate() {
      this.dbUpdateCommands = [];
      this.pendingUploadFiles = [];
      this.logoUploadedFiles = [];
    },

    ChangeIsAContactPerson() {
      // 如果是自动更新过程中，不执行自动更新逻辑（避免循环）
      if (this.isAutoUpdatingContactPerson) {
        return;
      }
      
      // 检查是否有至少一个选项被勾选
      const hasAnyChecked = this.UserData.notifyAds ||
        this.UserData.notifyEnquiry ||
        this.UserData.notifySourcing ||
        this.UserData.notifySystem ||
        this.UserData.notifyNameCard ||
        this.UserData.notifyBookmark;

      // 标记这是自动更新，避免触发全选操作
      this.isAutoUpdatingContactPerson = true;
      
      // 只要存在一个被勾选，顶部按钮就自动勾上
      if (hasAnyChecked) {
        this.SetasContactPerson = true;
      } else {
        // 如果所有选项都取消，顶部按钮也取消
        this.SetasContactPerson = false;
      }
      
      // 在下一个tick重置标志
      this.$nextTick(() => {
        this.isAutoUpdatingContactPerson = false;
      });
    },
    async LeavePage() {
      const result = await this.showLeavePageAfterSave(
        this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Title'),
        this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Body'),
        this.$t('lbl_EMPBE_CompanyInfo_Submit'),
      );

      if (result.isDenied) {
        return 0;
      } else if (result.isConfirmed) {
        return 1;
      } else {
        return 2;
      }
    },
    async onHidden() {
      // 在侧边栏隐藏前触发LeavePage事件
      // 检查是否有未保存的更改
      if (this.$store.state.dirty) {
        const shouldSave = await this.LeavePage();

        if (shouldSave == 0) {
          // 用户选择不保存或取消，直接关闭
          this.$store.state.dirty = false;
          this.Temp_Value = false;
        } else if (shouldSave == 1) {
          // 用户选择保存，执行保存操作
          this.Save();
        }
      } else {
        // 没有未保存的更改，直接关闭
        this.$store.state.dirty = false;
        this.Temp_Value = false;
      }
    },
    //重置表单验证
    resetFormVerify() {
      try {
        this.$refs.UserSettingObserver?.reset?.();
      } catch (e) {
        /* dialog 未挂载时忽略 */
      }
    },
    async getCellCountryOptions() {
      this.cellCountryOptions = (await CompanyInfoService.GetCellCountryData()).map(item => {
        return {
          id: item.Code,
          label: '+' + item.Option
        }
      });
    },
    DefaultCompanyfirstName(Name) {
      // 检查Name是否存在且为字符串
      if (!Name || typeof Name !== 'string') {
        return "";
      }

      // 安全地调用replaceEmTag方法（如果存在）
      let processedName = Name;
      if (typeof Name.replaceEmTag === 'function') {
        processedName = Name.replaceEmTag();
      }

      // 移除非中文、英文字母和数字的字符
      const cleanedName = processedName.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '');

      // 返回第一个字符，如果是英文字母则转换为大写
      if (cleanedName.length > 0) {
        const firstChar = cleanedName[0];
        // 如果是英文字母，转换为大写
        if (/[a-zA-Z]/.test(firstChar)) {
          return firstChar.toUpperCase();
        }
        return firstChar;
      }
      return '';
    },
    async GetCurrentDisplayContactCardFunc() {
      userService.GetCurrentDisplayContactCard().then(res => {
        if (res.isSuccessful) {
          const apiOtherAccountUserId = this.UserData?.otherAccountUserId || 0;
          this.AccountUserData = res.data ?? {};
          
          // 如果 GetUserDetailFunc 已经设置了正确的值，则使用它
          if (apiOtherAccountUserId > 0) {
            this.AccountUserData.otherAccountUserId = apiOtherAccountUserId;
          }
        } else if (!res.isSuccessful && res.systemErrorMsg) {
          this.$Alert(0, res.systemErrorMsg);
        }
      });
    },
    async GetUserDetailFunc() {
      this.$store.state.dirty = false;
      this.IsCreated = true;
      if (this.AccountUserId != 0) {
        this.resetFilePendingUpdate();
        this.IsDialogLoading = true;

        const currentUser = this.$store?.state?.authentication?.user;
        const isSuperAdmin = currentUser?.IsFullAccess === true;
        
        // 超级管理员模式下，使用 GetUserDetailByAdministrator
        const apiCall = (isSuperAdmin && this.companyId)
          ? userService.GetUserDetailByAdministrator({
              accountId: Number(this.companyId),
              accountUserId: this.AccountUserId,
              langId: this.langid
            })
          : userService.GetUserDetail({ 
              accountUserId: this.AccountUserId, 
              LangId: this.langid 
            });
        
        apiCall.then(res => {
          if (res.isSuccessful) {
            const finalDisplayContactCard = res.data.displayContactCard == '0' ? false : true;
            const otherAccountUserId = Number(res.data.otherAccountUserId || 0);
            
            this.$nextTick(() => {
              const rawDisable = res.data.isDisable ?? res.data.IsDisable;
              this.UserData = {
                ...res.data,
                isDisable: rawDisable === true || rawDisable === 1 || rawDisable === '1',
                displayContactCard: finalDisplayContactCard,
                otherAccountUserId: otherAccountUserId,
                notifySystem: res.data.notifySystem == '1' ? true : false,
                notifySourcing: res.data.notifySourcing == '1' ? true : false,
                notifyEnquiry: res.data.notifyEnquiry == '1' ? true : false,
                notifyAds: res.data.notifyAds == '1' ? true : false,
                // notifyNameCard may not exist in older API responses; default false
                notifyNameCard: res.data.notifyNameCard == '1' ? true : false,
                // notifyBookmark may not exist in older API responses; default false
                notifyBookmark: res.data.notifyBookmark == '1' ? true : false,
                // isExchangeNameCard: 后端返回 '1'/'0' 字符串，需要转换为布尔值
                isExchangeNameCard:res.data.isExchangeNameCard == '1' ? true : false,
              };

              this.logoUploadedFiles = res.data.userLogo ? [
                getInitImageDataObj(
                  { imageId: this.AccountUserId, cdnLink: res.data.userLogo, orderId: 1, usageType: this.fileUsageType },
                  { id: this.AccountUserId, orderId: 1, cdnLink: res.data.userLogo, usageType: this.fileUsageType }
                )
              ] : [];
              
              // 强制同步 AccountUserData.otherAccountUserId 为 API 返回值
              if (this.AccountUserData) {
                this.AccountUserData.otherAccountUserId = otherAccountUserId;
                if (res.data.displayContactCardPersonNameSc) {
                  this.AccountUserData.displayContactCardPersonNameSc = res.data.displayContactCardPersonNameSc;
                }
                if (res.data.displayContactCardPersonNameEn) {
                  this.AccountUserData.displayContactCardPersonNameEn = res.data.displayContactCardPersonNameEn;
                }
              }
              this.IsDialogLoading = false;
              // 回填后的联动/组件规范化不应算未保存
              this.$store.state.dirty = false;
            })
            this.CheckRoleFunc();
          } else if (!res.isSuccessful && res.systemErrorMsg) {
            this.Temp_Value=false;
            this.$Alert(0, res.systemErrorMsg);
          }

          if (!res.isSuccessful) {
            this.LogPageFormError({ res }, "Get_UserSetting");
          }

        }).catch((error) => {
          this.LogPageFormError({
            Error: {
              ErrorName: error.name,
              ErrorMessage: error.message,
              ErrorStack: error.stack
            }
          }, "Get_UserSetting");
        }).finally(() => {
          this.$nextTick(() => {
            setTimeout(() => {
              this.$store.state.dirty = false;
              this.IsCreated = false;
            }, 500);
          });
        });
      } else {

        // 新增用户时，自动设置首选通讯语言为当前界面语言
        const currentLangId = this.langid ? String(this.langid) : '1252';
        // 确保当前语言ID在LangOptions中存在
        const langExists = this.LangOptions.some(option => option.id === currentLangId);
        if (langExists) {
          this.UserData.mainLangId = currentLangId;
        } else {
          // 如果当前语言不在选项中，使用默认值
          this.UserData.mainLangId = '1252';
        }
        this.CheckRoleFunc();
        this.$nextTick(() => {
          setTimeout(() => {
            this.$store.state.dirty = false;
            this.IsCreated = false;
          }, 500);
        });
      }
    },
    CheckRoleFunc() {
      if (this.AccountUserId === 0) {
        this.isCanDelete = true;
        return;
      }

      this.isCheckingDeletePermission = true;
      userService.CheckRole({ DelAccoutUserId: this.AccountUserId }).then(res => {
        const resultValue = (res && typeof res === 'object' && 'isSuccessful' in res) ? res.data : res;
        this.isCanDelete = resultValue === true;
      }).catch((error) => {
        this.LogPageFormError({
          Error: {
            ErrorName: error.name,
            ErrorMessage: error.message,
            ErrorStack: error.stack
          }
        }, "CheckRole");

        this.isCanDelete = true;
      }).finally(() => {
        this.isCheckingDeletePermission = false;
      });
    },
    GetRoleOptionsFunc() {
      userService.GetRoleOptions().then((res) => {
        if (res.isSuccessful) {
          const allOptions = res.data.map(item => {
            const role = item['userRole'];
            let translatedLabel = role;
            if (role) {
              const roleLower = String(role).toLowerCase();
              if (roleLower === 'admin') {
                translatedLabel = this.$t('EMP_UserSetting_Role_Admin');
              } else if (roleLower === 'member') {
                translatedLabel = this.$t('EMP_UserSetting_Role_Member');
              }
            }
            return {
              id: role,
              label: translatedLabel
            };
          });
          this.AllRoleOptions = allOptions;
          this.applyRoleOptionsFilter();
        }
      });
    },
    applyRoleOptionsFilter() {
      const all = this.AllRoleOptions || [];
      // 只保留 ADMIN/MEMBER；Inactive 用 IsDisable，不再拼 NOPERMISSION 选项
      this.RoleOptions = all.filter(o => {
        const id = String(o.id || '').toUpperCase();
        return id === 'ADMIN' || id === 'MEMBER';
      });
    },
    EditDialog(type) {
      if (type == 'Mobile') this.ModalType = 0;
      else if (type == 'Email') this.ModalType = 1;
      this.emailMobileData.emailInput = this.UserData.emailValue;
      this.emailMobileData.mobileInput = this.UserData.phoneValue;
      this.emailMobileData.contactPhoneCountryCode = this.UserData.phoneCountry;
      this.emailMobileData.contactPhoneCountry = this.GetPhoneDetailPrefix;
      this.emailMobileData.emailIsVerify = this.UserData.emailIsVerify;
      this.emailMobileData.phoneIsVerify = this.UserData.phoneIsVerify;
      this.ShowModal = true;
    },
    async SaveEmailMobileFunc(obj) {
      
      // 规范化手机号（移除用户输入的前导 +，避免出现 ++）
      const sanitizedMobileInput = obj.mobileInput ? String(obj.mobileInput).replace(/^\+/, '') : '';

      // 检查手机号是否重复
      if (this.ModalType == 0 && sanitizedMobileInput) {
        this.phoneDuplicateError = false;
        try {
          const phoneCheckResult = await userService.CheckUserRoleAccount({
            LangId: this.langid,
            PhoneValue: sanitizedMobileInput,
            PhoneCountry: obj.contactPhoneCountryCode || '86',
            AccountUserId: this.AccountUserId || 0
          });
          
          if (phoneCheckResult && phoneCheckResult.isSuccessful && phoneCheckResult.data === true) {
            this.phoneDuplicateError = true;
          }
        } catch (error) {}
      }

      // 检查邮箱是否重复
      if (this.ModalType == 1 && obj.emailInput) {
        this.emailDuplicateError = false;
        try {
          const emailCheckResult = await userService.CheckUserRoleAccount({
            LangId: this.langid,
            EmailValue: obj.emailInput,
            AccountUserId: this.AccountUserId || 0
          });
          
          if (emailCheckResult && emailCheckResult.isSuccessful && emailCheckResult.data === true) {
            this.emailDuplicateError = true;
          }
        } catch (error) {}
      }

      // 如果有重复错误，不保存并保持弹窗打开（仅显示内联错误，不弹框）
      if (this.phoneDuplicateError || this.emailDuplicateError) {
        return;
      }

      // 检查是否有实际改动
      let hasChanged = false;
      if (this.ModalType == 0) {
        // 手机号：检查是否有改动
        const oldPhoneValue = (this.UserData.phoneValue || '').replace(/^\+/, '');
        const oldPhoneCountry = this.UserData.phoneCountry || '';
        hasChanged = (sanitizedMobileInput !== oldPhoneValue) || 
                     (obj.contactPhoneCountryCode !== oldPhoneCountry);
      } else if (this.ModalType == 1) {
        // 邮箱：检查是否有改动
        const oldEmailValue = this.UserData.emailValue || '';
        hasChanged = (obj.emailInput !== oldEmailValue);
      }
      
      // 没有重复，正常保存
      this.UserData.emailValue = obj.emailInput;
      this.UserData.phoneValue = sanitizedMobileInput;
      this.UserData.phoneCountry = obj.contactPhoneCountryCode;
      this.UserData.emailIsVerify = obj.emailIsVerify;
      this.UserData.phoneIsVerify = obj.phoneIsVerify;
      // 保存成功后，统一关闭当前弹框
      this.ShowModal = false;
      
      // 全新功能：当在"编辑用户"模式下，完成电话/电邮改动时，自动触发一次保存
      // 只有当用户实际改动了内容时才触发自动保存（如果只是点击OK没有改动，不触发）
      if (this.AccountUserId != 0 && hasChanged) {
        this.$nextTick(() => {
          this.Save(true); // 传递 true 表示这是自动保存，保存成功后不关闭侧边栏
        });
      }
    },
    DelEmailMobileFunc(obj) {
      // 检查用户是否是展台代表或联系人
      const isEBoothRep = this.UserData.displayContactCard;
      const isContactPerson = this.SetasContactPerson;
      
      // 检查删除后是否还有至少一种联系方式
      let willHaveContact = false;
      if (this.ModalType == 0) {
        // 删除手机号，检查是否还有邮箱
        willHaveContact = !!this.UserData.emailValue;
      } else if (this.ModalType == 1) {
        // 删除邮箱，检查是否还有手机号
        willHaveContact = !!this.UserData.phoneValue;
      }
      
      // 如果是展台代表或联系人，且删除后没有联系方式，则不允许删除
      if ((isEBoothRep || isContactPerson) && !willHaveContact) {
        this.showOnlyOkShow(
          this.$t('EMP_UserSetting_MobileOrEmailCannotBeRemoved'),
          this.$t('EMP_UserSetting_MobileOrEmailCannotBeRemovedMsg'),
          this.$t('lbl_EMPBE_Confirm')
        );
        return;
      }
      
      // 允许删除
      if (this.ModalType == 0) {
        this.UserData.phoneValue = '';
        this.UserData.phoneCountry = '';
        this.UserData.phoneIsVerify = false;
        this.phoneDuplicateError=false;
      } else if (this.ModalType == 1) {
        this.UserData.emailValue = '';
        this.UserData.emailIsVerify = false;
        this.emailDuplicateError=false;
      }
      this.ShowModal = false;
    },
    SavePasswordFunc(obj) {
      this.$set(this.UserData, 'passwordIsVerify', true);
      this.$set(this.UserData, 'passwordValueText', obj.text);
      this.$set(this.UserData, 'passwordValueVector', obj.vector);
      this.ShowModal = false;
      
      // 自动触发一次保存（仅在编辑用户模式下）
      if (this.AccountUserId != 0) {
        this.$nextTick(() => {
          this.Save(true); // 传递 true 表示这是自动保存，保存成功后不关闭侧边栏
        });
      }
    },
    ChangePassword() {
      if (!this.UserData.phoneValue && !this.UserData.emailValue) {
        this.showOnlyOkShow(this.$t('EMP_UserSetting_PleaseSetUpMobileOrEmail'), this.$t('EMP_UserSetting_CannotSetPasswordWithoutMobileEmail'), this.$t('lbl_EMPBE_Confirm'));
        return;
      }
      this.ModalType = 2;
      this.ShowModal = true;
    },
    handleAddPendingFileImages(dataArr) {
      const usageType = 'UserLogo';
      const pathEndpoint = 'Image';

      return dataArr.reduce((acc, curr) => {
        if (!curr.file) return acc;

        return [...acc, {
          id: `${curr.imageId || curr.id || '1'}`,
          file: curr.file,
          fileName: curr.name || 'UserLogo.jpg',
          fileExtension: curr.fileExtension || 'jpg',
          pathEndpoint,
          usageType,
        }];
      }, []);
    },

    fileUploadHandle() {
      const pendingFiles = [...this.pendingUploadFiles];
      const commands = [...this.dbUpdateCommands];
      const userIconUsageType = this.fileUsageType;

      // 无待上传文件时不要弹出「正在提交资料与档案」（启用/停用也会走 Save）
      if (!pendingFiles.length) {
        return Promise.resolve({
          status: 'AllSuccess',
          successfulList: [],
          failedList: [],
          commands,
        });
      }

      return this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit: false,
        pendingFiles,
        commands,
        getFailedText: {
          [userIconUsageType]: this.$t("EMP_UserSetting_ProfilePicture"),
        },
        uploadFinishCallback: this.uploadFinish
      });
    },
    async AfterSaveResult() {
      let userLogo = this.logoUploadedFiles && this.logoUploadedFiles.length > 0 ? this.logoUploadedFiles[0].cdnLink : '';

      try {
        const res = await this.fileUploadHandle();

        if (res.successfulList && res.successfulList.length > 0) {
          userLogo = res.successfulList[0].uploadedOssUrl;
        } else if (res.commands && res.commands.length > 0 && res.commands.find(item => item.command === 'DELETE' && item.usageType === this.fileUsageType)) {
          userLogo = '';
        }
      } catch (error) {
        this.LogPageFormError({
          Error: {
            ErrorName: error.name,
            ErrorMessage: error.message,
            ErrorStack: error.stack
          }
        }, "Delete_UserSetting");

        this.UserData.validationErrorLog += error
      }
      
      return {
        ...this.UserData,
        LangId: this.langid,
        userLogo,
      };
    },
    async DisableUser() {
      if (!this.CanDisableUser) return;
      /* 与 EPO 批量停用确认框同一套文案（单人 count=1） */
      const title = this.$t('lbl_EMPBE_EPO_SelectInactive_ConfirmTitleSingle');
      const text = this.$t('lbl_EMPBE_EPO_SelectInactive_ConfirmBodySingle');
      const confirmButton = this.$t('lbl_EMPBE_EPO_SelectInactive_Confirm');
      const cancelButton = this.$t('lbl_EMPBE_EPO_SelectInactive_Cancel');
      const result = await this.showCustomConfirmADD(title, text, confirmButton, cancelButton);
      if (!(result && result.value)) return;

      await this.toggleDisableAndSave(true);
    },
    async EnableUser() {
      if (!this.CanEnableUser) return;
      const title = this.$t('lbl_EMPBE_EPO_SelectInactive_ActivateTitle');
      const text = this.$t('lbl_EMPBE_EPO_SelectInactive_ActivateBody');
      const confirmButton = this.$t('lbl_EMPBE_EPO_SelectInactive_ActivateConfirm');
      const cancelButton = this.$t('lbl_EMPBE_EPO_SelectInactive_Cancel');
      const result = await this.showCustomConfirmADD(title, text, confirmButton, cancelButton);
      if (!(result && result.value)) return;

      // 清除停用标志，保留原 UserRole（ADMIN/MEMBER）
      await this.toggleDisableAndSave(false);
    },
    /** 停用/启用：先改本地再提交；失败整单回滚，成功通知列表刷新 */
    async toggleDisableAndSave(nextDisable) {
      const wasDirty = this.$store.state.dirty;
      const prevContactPerson = this.SetasContactPerson;
      const snapshot = JSON.parse(JSON.stringify(this.UserData));
      let ok = false;

      try {
        this.UserData.isDisable = nextDisable;
        this.applyRoleOptionsFilter();
        ok = await this.Save(false, nextDisable
          ? {
            title: this.$t('lbl_EMPBE_EPO_SelectInactive_SuccessTitle'),
            text: this.$t('lbl_EMPBE_EPO_SelectInactive_Success', { count: 1 }),
          }
          : {
            title: this.$t('lbl_EMPBE_EPO_SelectInactive_ActivateSuccessTitle'),
            text: this.$t('lbl_EMPBE_EPO_SelectInactive_ActivateSuccessBody'),
          });
      } catch (e) {
        ok = false;
        this.LogPageFormError({
          Error: {
            ErrorName: e?.name,
            ErrorMessage: e?.message,
            ErrorStack: e?.stack
          }
        }, "ToggleDisable_UserSetting");
      }

      if (ok) {
        this.$emit('refresh');
        return;
      }

      this.IsCreated = true;
      this.UserData = snapshot;
      this.SetasContactPerson = prevContactPerson;
      this.applyRoleOptionsFilter();
      this.$nextTick(() => {
        this.IsCreated = false;
        this.$store.state.dirty = wasDirty;
      });
    },
    async Delete() {
      const title = this.$t('lbl_EMPBE_DeleteThisUser', { selected: 1 });
      const text = this.$t('lbl_EMPBE_DeleteUserWarning');
      const confirmButton = this.$t('lbl_EMPBE_Delete');
      const cancelButton = this.$t('lbl_EMPBE_Cancel');

      // 显示确认对话框
      const result = await this.showCustomConfirmDEL(title, text, confirmButton, cancelButton);

      // 如果用户确认删除，则执行删除操作
      if (result && result.value) {
        const currentUser = this.$store?.state?.authentication?.user;
        const isSuperAdmin = currentUser?.IsFullAccess === true;
        const that = this;
        
        const apiCall = (isSuperAdmin && this.companyId)
          ? userService.DelRoleByAdministrator({
              accountId: Number(this.companyId),
              accountUserId: currentUser?.accountUserId || currentUser?.AccountUserId || -1,
              DelAccoutUserId: this.AccountUserId,
              LangId: this.langid
            })
          : userService.DelRole({
              DelAccoutUserId: this.AccountUserId,
              LangId: this.langid
            });

        apiCall.then((res) => {
          if (res.isSuccessful) {
            that.showSubmitSucess(
              that.$t('lbl_EMPBE_EPO_SelectInactive_DeleteSuccessTitle'),
              that.$t('lbl_EMPBE_EPO_SelectInactive_DeleteSuccessBody', { count: 1 }),
            );
            that.$emit('refresh');
            that.Temp_Value = false;
          } else {
            that.showResultMessagePopup(false, that.$t('lbl_EMPBE_DeleteFailed'), true);
            that.LogPageFormError({ res }, "Delete_UserSetting");
          }
        }).catch((error) => {
          this.LogPageFormError({
            Error: {
              ErrorName: error.name,
              ErrorMessage: error.message,
              ErrorStack: error.stack
            }
          }, "Delete_UserSetting");
        });
      }
    },
    SaveService(data, isAutoSave = false, successCopy = null) {
      this.IsDialogLoading = true;
      const currentUser = this.$store?.state?.authentication?.user;
      const isSuperAdmin = currentUser?.IsFullAccess === true;
      
      const apiCall = (isSuperAdmin && this.companyId)
        ? userService.AddOrEditRoleByAdministrator(
            data,
            Number(this.companyId),
            currentUser?.accountUserId || currentUser?.AccountUserId || -1
          )
        : userService.AddOrEditRole(data);

      return apiCall.then((res) => {
        const failMsg = (!res.isSuccessful)
          ? (
              (Array.isArray(res.msg) && res.msg.includes('EPO_ROLE_QUOTA_EXCEEDED'))
                ? this.$t('EMP_UserSetting_RoleQuotaFull')
                : (Array.isArray(res.systemErrorMsg) && res.systemErrorMsg[0])
                  || (Array.isArray(res.msg) && res.msg[0])
                  || ''
            )
          : '';
        if (res.isSuccessful && successCopy) {
          this.$submitFormMessage.HideMessagePopup();
          this.showSubmitSucess(successCopy.title, successCopy.text);
        } else {
          this.showResultMessagePopup(res.isSuccessful, failMsg, true);
        }

        if (res.isSuccessful) {
          // 清除 dirty 状态
          this.$store.state.dirty = false;
          // 防止保存成功后自动显示密码设置弹窗
          this.ShowModal = false;
          this.ModalType = 0;
          
          // 如果是自动保存（从email/mobile保存触发），不关闭侧边栏
          // 列表刷新：关抽屉走 Showdialog watch；停用/启用另 emit refresh
          if (!isAutoSave) {
            // 手动保存时，使用和 X 按钮相同的方式关闭侧边栏
            // 直接设置 Temp_Value = false，和 X 按钮的逻辑一致
            this.Temp_Value = false;
          }
          return true;
        }
        this.LogPageFormError({ res }, "Save_UserSetting");
        return false;
      }).catch((error) => {
        this.LogPageFormError({
          Error: {
            ErrorName: error.name,
            ErrorMessage: error.message,
            ErrorStack: error.stack
          }
        }, "Save_UserSetting");
        return false;
      }).finally(() => {
        this.IsDialogLoading = false;
      });
    },
    validateMinTwoChars() {
      const checks = [
        { key: 'personNameEn', label: this.$t('EMP_UserSetting_FullNameEnglish') },
        { key: 'personNameSc', label: this.$t('EMP_UserSetting_FullNameChinese') },
        { key: 'jobTitleEn', label: this.$t('EMP_UserSetting_JobTitleEnglish') },
        { key: 'jobTitleSc', label: this.$t('EMP_UserSetting_JobTitleChinese') }
      ];
      for (const item of checks) {
        const value = String(this.UserData?.[item.key] || '').trim();
        if (value.length < 2) {
          this.showResultMessagePopup(false, this.$t('lbl_EMPBE_FieldMin2Chars', { fieldName: item.label }), true);

          return false;
        }
      }
      return true;
    },
    async Save(isAutoSave = false, successCopy = null) {
      // 如果第一个参数是事件对象（手动点击按钮），则设置为 false
      if (isAutoSave && typeof isAutoSave === 'object' && isAutoSave.target) {
        isAutoSave = false;
      }

      const data = await this.AfterSaveResult();
      
      //写日志
      const query = {
        FormId: this.accountUserId,
        Action: 'Save',
        FormType: 'User_Setting',
        ErrorLog: data.validationErrorLog || ''
      };
      LogService.LogFormDataWithObj(query, data);

      const observer = this.$refs.UserSettingObserver;
      if (!observer || typeof observer.validate !== 'function') {
        return false;
      }

      const res = await observer.validate();
      if (!res.valid) {
        this.$submitFormMessage.HideMessagePopup();
        return false;
      }
      if (!this.validateMinTwoChars()) {
        return false;
      }

      const currentRepresentativeId = this.UserData.otherAccountUserId || 0;
      if (currentRepresentativeId > 0
        && currentRepresentativeId != this.AccountUserId
        && this.UserData.displayContactCard
      ) {
        const title = this.$t('lbl_EMPBE_ChangeRepresentative');
        const text = this.$t('lbl_EMPBE_RepresentativeWarning');
        const confirmButton = this.$t('lbl_EMPBE_ConfirmChange');
        const cancelButton = this.$t('lbl_EMPBE_Cancel');

        const result = await this.showCustomConfirmADD(title, text, confirmButton, cancelButton);
        if (!(result && result.value)) {
          this.$submitFormMessage.HideMessagePopup();
          return false;
        }
      }

      return await this.SaveService(data, isAutoSave, successCopy);
    }

  },
};
</script>
<style>
  .User-Dialog .b-sidebar{
    min-width: 600px !important;
    width: 30% !important;
    max-height: 100vh !important;
  }
.user-setting-sidebar .b-sidebar-backdrop {
  display: none !important;
}

/* 确保在供应商详情页面中也能正确显示 */
.User-Dialog .b-sidebar {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  height: 100vh !important;
  z-index: 1050 !important;
}
</style>
<style scoped>
.Button-Group {
  width: 100%;
  /* position: fixed;
  right: 0px;
  bottom: -10px;
  z-index: 8; */
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  /* padding: 0px 24px 24px 24px; */
  background: white;
}

/* 当只有一个按钮时，让它靠右对齐 */
.Button-Group.single-button {
  justify-content: flex-end;
}

/* 确保 Save 按钮始终在右下角，即使 Delete 按钮不显示 */
.Button-Group:not(:has(.single-Delete)) {
  justify-content: flex-end;
}
.UserSeeting-Nav-Item-Left-Content
{
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.UserSeeting-Nav-Item-Left-PasswordLabel {
  color: rgba(0, 0, 0, 0.80);
  font-size: 12px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  line-height: 15.60px;
  word-wrap: break-word;
}
.UserSeeting-Nav-AccountActions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.UserSeeting-Nav-AccountActions-Card {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

.UserSeeting-Nav-AccountActions-Row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 20px;
}

.UserSeeting-Nav-AccountActions-Divider {
  height: 1px;
  margin: 0 20px;
  background: rgba(0, 0, 0, 0.1);
}

.UserSeeting-Nav-AccountActions-Copy {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.UserSeeting-Nav-AccountActions-Label {
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
}

.UserSeeting-Nav-AccountActions-Tip {
  color: rgba(0, 0, 0, 0.8); /* #00000080 */
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
}

.UserSeeting-Nav-AccountActions-Btn {
  flex-shrink: 0;
  box-sizing: border-box;
  height: 36px;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.UserSeeting-Nav-AccountActions-Btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.UserSeeting-Nav-AccountActions-Btn--primary {
  color: #7366ff;
  border-color: #7366ff;
}

.UserSeeting-Nav-AccountActions-Btn--primary:hover:not(:disabled),
.UserSeeting-Nav-AccountActions-Btn--primary:focus:not(:disabled) {
  background: rgba(115, 102, 255, 0.06);
}

.UserSeeting-Nav-AccountActions-Btn--success {
  color: #fff;
  border-color: #007f14;
  background: #007f14;
}

.UserSeeting-Nav-AccountActions-Btn--success:hover:not(:disabled),
.UserSeeting-Nav-AccountActions-Btn--success:focus:not(:disabled) {
  background: #006b11;
  border-color: #006b11;
}

.UserSeeting-Nav-AccountActions-Btn--danger {
  color: #dc3545;
  border-color: #dc3545;
}

.UserSeeting-InactiveBanner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  border-radius: 12px;
  background: #fffce5;
}

.UserSeeting-InactiveBanner__icon {
  flex-shrink: 0;
  width: 17px;
  height: 17px;
  margin-top: 2px;
  display: block;
}

.UserSeeting-InactiveBanner__content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.UserSeeting-InactiveBanner__title {
  color: rgba(0, 0, 0, 0.8);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}

.UserSeeting-InactiveBanner__body {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
}

/* 包一层 FormBody（Inactive 只读）后，需自行继承原 UserSetting-Nav 的区块间距 */
.UserSetting-Nav-FormBody {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

.UserSetting-Nav-FormBody.is-readonly {
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}

.UserSeeting-Nav-AccountActions-Btn--danger:hover:not(:disabled),
.UserSeeting-Nav-AccountActions-Btn--danger:focus:not(:disabled) {
  background: rgba(220, 53, 69, 0.06);
}

.UserSeeting-Nav-Item-Error {
  color: #DC3545;
  font-size: 12px;
  font-weight: 400;
  line-height: 15.60px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.displayContactCard {
  display: flex;
  gap: 16px;
  border-radius: 8px;
  align-items: center;
}

.displayContactCard-Div {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.displayContactCard-Div-Header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.OnlydisplayContactCard-Name {
  color: rgba(0, 0, 0, 0.40);
  font-size: 12px;
  font-weight: 400;
  line-height: 15.60px;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.OnlydisplayContactCard-Name span {
  color: rgba(0, 0, 0, 0.40);
  font-size: 12px;
  font-weight: 400;
  line-height: 15.60px;
  word-wrap: break-word
}

.OnlydisplayContactCard {
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.03);
  padding: 16px;
  gap: 16px;
}

.displayContactCard-Div-Title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 700;
  line-height: 18.20px;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.displayContactCard-Div-Text {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.displayContactCard-Div-Text :deep(*) {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.displayContactCard-AutoRow-Content {
  min-width: 0;
}

.UserSeeting-Nav-Img-None {
  width: 78px;
  height: 78px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: linear-gradient(0deg, rgba(115, 102, 255, 0.08) 0%, rgba(115, 102, 255, 0.08) 100%);
  overflow: hidden;
  border: 1px dashed #7366FF;
}

.UserSeeting-Nav-Img-None-Pen {
  position: absolute;
  right: 0px;
  bottom: 0px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background-color: #F9F9F9;
  pointer-events: auto;
  cursor: pointer;
  transition: background-color 0.2s ease;
  z-index: 1;
}

.UserSeeting-Nav-Img-None-Pen i {
  pointer-events: none;
}

.UserSeeting-Nav-Img-None-Pen[data-v-2363308f] {
  background-color: #F9F9F9;
}

.UserSeeting-Nav-Img-None-Pen[data-v-2363308f]:hover {
  background-color: #F9F9F9;
}

/* hover 整个头像区域时也高亮笔 icon */
.UserSeeting-Nav-Img-None:hover .UserSeeting-Nav-Img-None-Pen,
.UserSeeting-Nav-Img:hover .UserSeeting-Nav-Img-None-Pen {
  background-color: #E2E1F0;
}

.UserSeeting-Nav-Img-None-text {
  width: 78px;
  height: 78px;
  background-image: url('https://cdn.adsalecdn.com/EMP/Backend/Images/AddPhoto.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  pointer-events: none;
}

.UserSeeting-Nav-Notifications-Footer-Left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.UserSeeting-Nav-Notifications-Footer-Right {
  flex: 1;
}

.UserSeeting-Nav-Notifications-Footer {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  outline: 1px rgba(0, 0, 0, 0.1) solid;
  border-radius: 8px;
}

.Expansionboard-Nav-Text {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word
}

.Expansionboard-Nav-TextBold {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 700;
  line-height: 20.80px;
  word-wrap: break-word
}

.Expansionboard-Nav-Header-tips {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.Expansionboard-Nav {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 16px;
}

.Expansionboard-Nav .form-group {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.UserSeeting-Nav-Notifications-Content {
  outline: 1px rgba(0, 0, 0, 0.10) solid;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.UserSeeting-Nav-Notifications {

  display: flex;
  flex-direction: column;
  gap: 16px;
}

.UserSeeting-Nav-Item-Right-Timer {
  color: rgba(0, 0, 0, 0.80);
  font-size: 12px;
  font-weight: 400;
  line-height: 15.60px;
  word-wrap: break-word
}

.UserSeeting-Nav-Item-Left-OtherTypeMsg-Tilte {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 700;
  line-height: 18.20px;
  word-wrap: break-word
}

.UserSeeting-Nav-Item-Left-OtherTypeMsg-Msg {
  color: rgba(0, 0, 0, 0.80);
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 15.60px;
  word-wrap: break-word
}

.UserSeeting-Nav-OtherType {

  display: flex;
  flex-direction: column;
  gap: 8px;
}

.UserSeeting-Nav-LoginType {

  display: flex;
  flex-direction: column;
  gap: 16px;
}

.UserSeeting-Nav-LoginType-Header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.UserSeeting-Nav-Item-Left-MsgVerify {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 4px;
}

.UserSeeting-Nav-Item-Left-MsgVerify span {
  margin: 0;
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-family: Inter, sans-serif;
  font-weight: 700;
  line-height: 18.20px;
  word-wrap: break-word;
}

.UserSeeting-Nav-Item-Left-MsgVerify .not-setup-text {
  font-size: 12px;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
  color:rgba(0, 0, 0, 0.80);
  word-wrap: break-word;
}

.UserSeeting-Nav-Item-Right {

  display: flex;
  gap: 16px;
  align-items: center;
  align-self: stretch;
}

.UserSeeting-Nav-Item-Right .btn-outline-primary {
  padding: .375rem .75rem;
}
.btn.btn-outline-primary {
  padding: .375rem .75rem;
}

.UserSeeting-Nav-Item-Left {
  display: flex;
  gap: 16px;
  align-items: center;
  align-self: stretch;

}

.UserSeeting-Nav-Item {
  outline: 1px rgba(0, 0, 0, 0.10) solid;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.UserSeeting-Nav-MobileMail-Content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.UserSeeting-Nav-MobileMail {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.UserSeeting-Nav-MobileMail-Header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.UserSeeting-Nav-ProfileDetails-Content .form-group {
  margin-bottom: 0rem !important;
}

.UserSeeting-Nav-ProfileDetails-Content {
  display: grid;
  grid-template-columns: 2fr 2fr;
  gap: 8px;
}

.UserSeeting-Nav-ProfileDetails {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.UserSeeting-Nav-Tips span {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word
}

.UserSeeting-Nav-Tips {
  display: flex;

}

.UserSeeting-Nav-Tips div {
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: #E7F8FF;
  border-radius: 24px;
}

/* Profile picture 提示条：按设计缩小 icon，避免撑高间距 */
.UserSeeting-Nav-Tips .UserSetting_Night_Icon {
  width: 20px;
  height: 20px;
}

.UserSeeting-Nav-Tips-Center {

  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  background: #E7F8FF;

}

.UserSeeting-Nav-Tips-Center-Nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.UserSeeting-Nav-Tips-Center-Title {
  color: rgba(0, 0, 0, 0.40);
  font-size: 11px;
  font-weight: 500;
  line-height: 14.30px;
  word-wrap: break-word
}

.UserSeeting-Nav-Tips-Center-Content {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word
}


.UserSeeting-Nav-size {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word
}

.UserSeeting-Nav-Recommend {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  padding: 4px 6px;
  background: #FFD02C;
  border-radius: 25px;
  margin-left: 0;
}

.UserSeeting-Nav-Recommend-Text {
  text-box-trim: trim-both;
  text-box-edge: cap alphabetic;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  color: rgba(0, 0, 0, 0.80);
  font-size: 12px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 18px;
  word-wrap: break-word;
  margin: 0;
  padding: 0;
}

.UserSeeting-Nav-Name {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.UserSeeting-Nav-Name .UserSeeting-Nav-Item-Title {
  width: auto;
}

.UserSeeting-Nav-Info {
  display: flex;
  flex-direction: column;
  gap: 8px;

}

.UserSeeting-Nav-Msg {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 16px;
}

.UserSeeting-Nav-Img {
  width: 78px;
  height: 78px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.UserSeeting-Nav-Img img {
  width: 78px;
  height: 78px;
  -o-object-fit: contain;
  object-fit: contain;
  border-radius: 999px;
  display: block;
  background: #fff;
}

.UserSeeting-Nav-Img-Upload {
  width: 78px !important;
  height: 78px !important;
  overflow: hidden !important;
  border: 1px dashed #7366FF !important;
  border-radius: 999px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.UserSeeting-Nav-Img-Upload ::v-deep .btn {
  cursor: pointer !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
  -webkit-tap-highlight-color: transparent !important;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  user-select: none !important;
}


.UserSeeting-Nav-Img-Upload ::v-deep .btn > * {
  pointer-events: none !important;
}


.UserSeeting-Nav-Img-Upload ::v-deep .collapsed {
  width: 78px !important;
  height: 78px !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 999px !important;
  overflow: hidden !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
  -webkit-tap-highlight-color: transparent !important;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  user-select: none !important;
}
.UserSeeting-Nav-Img-Upload ::v-deep .not-collapsed {
  width: 78px !important;
  height: 78px !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 999px !important;
  overflow: hidden !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
  -webkit-tap-highlight-color: transparent !important;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  user-select: none !important;
}


.UserSeeting-Nav-Img-Upload ::v-deep .collapsed:focus,
.UserSeeting-Nav-Img-Upload ::v-deep .collapsed:active,
.UserSeeting-Nav-Img-Upload ::v-deep .collapsed:hover {
  outline: none !important;
  box-shadow: none !important;
  background-color: inherit !important;
  border-color: inherit !important;
  transform: none !important;
  transition: none !important;
}

.UserSeeting-Nav-Img-Upload ::v-deep .collapsed > * {
  pointer-events: none !important;
}

.UserSeeting-Nav-Img-Upload ::v-deep .collapsed img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  -o-object-fit: cover !important;
  border-radius: 999px !important;
  margin: 0 !important;
  padding: 0 !important;
}

.UserSeeting-Nav-Img-Upload ::v-deep .collapsed {
  width: 78px !important;
  height: 78px !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 999px !important;
  overflow: hidden !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: linear-gradient(0deg, rgba(115, 102, 255, 0.08) 0%, rgba(115, 102, 255, 0.08) 100%) !important;
  cursor: pointer !important;
}

.UserSeeting-Nav-Img-Upload ::v-deep .collapsed.selected {
  background: #fff !important;
}

.UserSeeting-Nav-Img-Upload ::v-deep .collapsed * {
  pointer-events: none !important;
}

.UserSeeting-Nav-HeadMsg {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  outline: 1px rgba(0, 0, 0, 0.10) solid;
  border-radius: 8px;
}

.UserSeeting-Nav-HeadLine {
  border: 1px solid rgb(240, 241, 242);
  height: 1px;
}

.UserSeeting-Nav-Role {
  display: flex;
  flex-direction: column;
  gap: 8px;

}

.UserSeeting-Nav-Role-Header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.UserSeeting-Nav-Item-Title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 16px;
  font-family: Inter, sans-serif;
  font-weight: 700;
  line-height: 20.80px;
  word-wrap: break-word;
  width: 100%;
}

.UserSeeting-Nav-Item-Msg {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word;
  width: 100%;
}


/* 确保 sidebar 的 z-index 足够高，不被其他元素遮挡 */
.user-setting-sidebar {
  z-index: 1050 !important;
}

/* 确保 sidebar body 可以滚动，内容不被遮挡 */
.user-setting-sidebar .b-sidebar-body {
  height: 100% !important;
  max-height: calc(100vh - 60px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  padding: 0 !important;
}

/* 确保内容区域可以正常滚动 */
.user-setting-sidebar .b-sidebar-body > * {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

/* 确保 UserSetting-Nav 内容可以滚动 */
.UserSetting-Nav {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: fit-content;
  overflow-y: visible;
}


</style>
<style>
.UserSettingDialog-header {
  padding: 16px !important;
  box-shadow: 0px 2px 15px rgba(183, 183, 183, 0.30) !important;
  border-bottom: 1px #F2F3F5 solid !important;

}

.UserSettingDialog-header-Div {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 18px;
  font-weight: 700;
  line-height: 23.40px;
  color: rgba(0, 0, 0, 0.80);
}
.UserSettingDialog-header-Title{
  font-size: 18px;
}
</style>
